import { render, staticRenderFns } from "./HerramientaExcel.vue?vue&type=template&id=81525bd0&"
import script from "./HerramientaExcel.vue?vue&type=script&lang=js&"
export * from "./HerramientaExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports